import { VideoComponentMediaAction } from "./state";

export function handleCommand(
  command: VideoComponentMediaAction,
  player: React.RefObject<HTMLVideoElement | null>,
): Promise<void> {
  const { current } = player;

  if (!current) {
    return Promise.reject(new Error("player-not-found"));
  }

  switch (command.type) {
    case "play": {
      return current.play();
    }

    case "pause": {
      return Promise.resolve(current.pause());
    }

    case "toggle-play": {
      if (current.paused) {
        return current.play();
      } else {
        return Promise.resolve(current.pause());
      }
    }

    case "set-volume": {
      if (command.value === 0) {
        current.volume = 0;
        current.muted = true;
      } else {
        current.volume = 1;
        current.muted = false;
      }

      return Promise.resolve();
    }

    case "set-progress": {
      const wasPlaying = !current.paused;

      if (wasPlaying) {
        current.pause();
      }

      const newCurrentTime = current.duration * command.value;

      if (Number.isFinite(newCurrentTime)) {
        current.currentTime = newCurrentTime;

        return wasPlaying ? current.play() : Promise.resolve();
      } else {
        return Promise.resolve();
      }
    }

    case "seek-by": {
      current.currentTime = current.currentTime + command.value * current.duration;

      return Promise.resolve();
    }

    case "toggle-fullscreen": {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return requestFullscreen(current).catch((e: unknown) => {
        console.error(e);
      });
    }
  }
}

function requestFullscreen(element: Element) {
  if (element.requestFullscreen) {
    return element.requestFullscreen();
  } else if ((element as any).mozRequestFullScreen) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (element as any).mozRequestFullScreen();
  } else if ((element as any).webkitRequestFullscreen) {
    (element as any).webkitRequestFullscreen();
    return Promise.resolve();
  } else if ((element as any).webkitEnterFullscreen) {
    (element as any).webkitEnterFullscreen();
    return Promise.resolve();
  } else {
    return Promise.reject(new Error("no-fullscreen-method"));
  }
}
